/**
 * MediaCaptureState
 * -----------------
 *
 * Lifecycle of local media acquisition from the client's point of view.
 *
 * IDLE:
 *   No media acquisition has started yet.
 *
 * ACQUIRING:
 *   Media acquisition is in progress.
 *
 * READY:
 *   Local media is available and ready for use.
 *
 * ERROR:
 *   Media acquisition failed or media subsystem is in an unusable state.
 */
export const MEDIA_CAPTURE_STATE = {
    IDLE: "IDLE",
    ACQUIRING: "ACQUIRING",
    READY: "READY",
    ERROR: "ERROR",
};
/**
 * MediaDeviceKind
 * ---------------
 *
 * Browser media device kinds normalized into a dedicated domain vocabulary.
 */
export const MEDIA_DEVICE_KIND = {
    AUDIO_INPUT: "audioinput",
    VIDEO_INPUT: "videoinput",
    AUDIO_OUTPUT: "audiooutput",
};
/**
 * makeEmptyDeviceInventory
 * ------------------------
 */
export function makeEmptyDeviceInventory() {
    return {
        audioInputs: [],
        videoInputs: [],
        audioOutputs: [],
    };
}
/**
 * makeInitialSelectedMediaDevices
 * -------------------------------
 */
export function makeInitialSelectedMediaDevices() {
    return {
        audioInputDeviceId: null,
        videoInputDeviceId: null,
        audioOutputDeviceId: null,
    };
}
/**
 * makeInitialLocalMediaState
 * --------------------------
 */
export function makeInitialLocalMediaState() {
    return {
        captureState: MEDIA_CAPTURE_STATE.IDLE,
        requestedAudio: true,
        requestedVideo: true,
        hasLocalStream: false,
        audio: {
            available: false,
            enabled: false,
        },
        video: {
            available: false,
            enabled: false,
        },
        selectedDevices: makeInitialSelectedMediaDevices(),
        devices: makeEmptyDeviceInventory(),
        isSpeaking: false,
        error: null,
    };
}
